// text imported from yad should fit TinyMCE with p-tags as replacement for any newlines
export function formatForTinyMCE(text: string) {
  if (!text) return '';
  // Split text into lines
  const lines = text.split(/\r\n|\r|\n/);
  // Process each line
  const processedLines = lines.map((line) => {
    // Check if line contains any HTML tags
    const hasTags = /<[^>]*>/.test(line);
    return hasTags ? line : `<p>${line}</p>`;
  });

  const result = processedLines.join('');

  // Apply TinyMCE tag conversions
  const convertedResult = result
    .replace(/<b>/g, '<strong>')
    .replace(/<\/b>/g, '</strong>')
    .replace(/<i>/g, '<em>')
    .replace(/<\/i>/g, '</em>');

  // Check if the entire result needs to be wrapped
  const trimmedResult = convertedResult.trim();

  // If no content, return empty
  if (!trimmedResult) return '';

  // Check if result starts and ends with any HTML tag
  const startsWithAnyTag = /^<[^>]+>/.test(trimmedResult);
  const endsWithAnyTag = /<\/[^>]+>$/.test(trimmedResult);

  if (
    (startsWithAnyTag && !endsWithAnyTag) ||
    (!startsWithAnyTag && endsWithAnyTag) ||
    (startsWithAnyTag &&
      endsWithAnyTag &&
      !(/^<div[^>]*>/.test(trimmedResult) && /<\/div>$/.test(trimmedResult)))
  ) {
    return `<div>${trimmedResult}</div>`;
  }

  if (
    !(/^<p[^>]*>/.test(trimmedResult) && /<\/p>$/.test(trimmedResult)) &&
    !(/^<div[^>]*>/.test(trimmedResult) && /<\/div>$/.test(trimmedResult))
  ) {
    return `<p>${trimmedResult}</p>`;
  }

  // If no tags at all at start and end, wrap in p
  return trimmedResult;
}
